document.addEventListener('DOMContentLoaded', function () {
  const tabSections = document.querySelectorAll('.prod_info_tab_main');
  if (!tabSections.length) return;

  tabSections.forEach(function (section) {
    const tabs = Array.from(section.querySelectorAll('.prod_info_tab_title_item'));
    const panels = Array.from(section.querySelectorAll('.prod_info_pannel_item'));

    if (!tabs.length || !panels.length) return;

    // -------------------------
    // ✅ DEFAULT ACTIVE FIX
    // -------------------------
    let activeTab = tabs.find(tab => tab.classList.contains('active'));

    if (!activeTab) {
      activeTab = tabs[0];
      activeTab.classList.add('active');

      const tabId = activeTab.getAttribute('data-tab-id');
      const defaultPanel = section.querySelector(
        '.prod_info_pannel_item[data-tab-id="' + tabId + '"]'
      );

      if (defaultPanel) {
        defaultPanel.removeAttribute('hidden');
        defaultPanel.classList.add('is-active');
      }
    }

    // -------------------------
    // CLICK HANDLER
    // -------------------------
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const tabId = tab.getAttribute('data-tab-id');

        // reset tabs
        tabs.forEach(t => t.classList.remove('active'));

        // reset panels
        panels.forEach(panel => {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        });

        // activate current tab
        tab.classList.add('active');

        // activate matching panel
        const activePanel = section.querySelector(
          '.prod_info_pannel_item[data-tab-id="' + tabId + '"]'
        );

        if (activePanel) {
          activePanel.removeAttribute('hidden');
          activePanel.offsetHeight; // reflow
          activePanel.classList.add('is-active');
        }
      });
    });
  });
});
